module.exports = __webpack_public_path__ + "static/img/banner2x.4a282e5c.png";